import { Heading, SimpleGrid, Button } from "@chakra-ui/react";
import { Meta, Card, Search, Reload } from "@/components/index";
import { apiRequest } from "@/utils/api";
import { motion } from "framer-motion";
// import useSWRImmutable from "swr/immutable";
export default function Home(props) {
  let data = props.data;
  if (data === null) {
    console.log("reload");
  }
  // const { data, error, isValidating } = useSWRImmutable(
  //   ["https://api.axenda.io/schools", props.cookie],
  //   apiRequest,
  //   {
  //     fallbackData: props.data,
  //   }
  // );
  return (
    <Meta
      title="Main Page"
      description="Axenda Drive main Page"
      image="https://axed.vercel.app/favicon-512.png"
    >
      <main>
        <Heading as="h1" textAlign="center" paddingY={"12"}>
          Hello in the 💽
        </Heading>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            aria-label="Go Chooes your university"
            as="a"
            href="#unis"
            textColor="blue.200"
          >
            Chooes your university 🛖
          </Button>
        </div>
        {data === null ? (
          <Reload size="xl" text={"Reload"} />
        ) : (
          <motion.div
            id="unis"
            transition={{ type: "tween", duration: 1.2 }}
            animate={{ opacity: 1 }}
            initial={{ opacity: 0.05 }}
          >
            <Search ph="University Name" />
            <SimpleGrid
              columns={[1, 2, 3, 4]}
              gap={8}
              justifyItems="center"
              justifyContent="space-evenly"
              alignContent="space-evenly"
              alignItems="center"
              // minChildWidth={["14rem", "16rem", "18rem"]}
              m={8}
            >
              {data?.map((deta, id) => {
                return (
                  <Card
                    key={deta._id != null ? deta._id : id}
                    img={deta.logoUrl}
                    slug={deta.slug}
                    name={deta.autocomplete}
                    simple
                  ></Card>
                );
              })}
            </SimpleGrid>
          </motion.div>
        )}
      </main>
    </Meta>
  );
}
export async function getServerSideProps(context) {
  // context.res.setHeader(
  //   "Cache-Control",
  //   "public, max-age=3600, s-maxage=3600, stale-while-revalidate"
  // );
  const cookie = context.req.cookies?.token;
  const query = context.req.__NEXT_INIT_QUERY?.q;
  let data = await apiRequest("https://api.axenda.io/schools", cookie);
  return { props: { data } };
}
